// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"850e78a2","208":"4008a9bf","451":"23029e2a","488":"1d234a9a","705":"0f9f4e13","897":"2351e216"}[chunkId] + ".chunk.js";
};